







































/**
 * Handles setting and modifying the tools used in Grapher
 */
import { Mutations } from "@/store/mutations";
import Vue from "vue";

export default Vue.extend({
  name: "MenuBottomUndo",
  computed: {
    canUndo(): boolean {
      return this.$store.getters.getCanUndo;
    },
    undoName(): string {
      return "Undo " + this.$store.getters.getUndoName;
    },
    redoName(): string {
      return "Redo " + this.$store.getters.getRedoName;
    },
    canRedo(): boolean {
      return this.$store.getters.getCanRedo;
    },
  },
  // },
  methods: {
    undo(): void {
      this.$store.commit(Mutations.UNDO);
    },
    redo(): void {
      this.$store.commit(Mutations.REDO);
    },
  },
});
